import Counter from './Counter'
const Apps = () => {
    return (
        <div>
            <h2>Redux Complete</h2>
            <Counter />
        </div>
    )
}

export default Apps